import { Observable } from "rxjs";
import { IdValue } from "./id-value";

export class FieldOptionsDescriptor {
    idPropertyName: string;
    valuePropertyName: string;
    fixedOptions: Array<any>;
    allowAddNewOptions: Boolean;

    constructor(
        idPropertyName: string,
        valuePropertyName: string,
        fixedOptions?: Array<any>,
        allowAddNewOptions?: Boolean
    ) {
        this.idPropertyName = idPropertyName;
        this.valuePropertyName = valuePropertyName;
        this.fixedOptions = fixedOptions;
        this.allowAddNewOptions = allowAddNewOptions || false;
    }
}
